export default {
  strict: true,
  namespaced: true,
  state: {
    user: '',
    userId: '',
    is_online: false,
    roles: [],
    departments: [],
    department_names: []
  },
  mutations: {
    setOAuth(state, payload) {
      let keys = Object.keys(payload);
      keys.map((k) => (state[k] = payload[k]));
    }
  },
  getters: {
    isAdmin: (state) => {
      return state.roles.includes('administrator');
    },
    hasRole: (state) => (roleName) => {
      return state.roles.includes(roleName);
    },
    departments: (state) => {
      return state.departments;
    },
    departmentNames: (state) => {
      return state.department_names || [];
    },
    // 是否属于 R&D 部门：直接用 SSO 下发的部门名判断
    isRD: (state) => {
      return (state.department_names || []).indexOf('R&D Department') !== -1;
    }
  }
};
